import React from "react"
import { Link } from 'react-router-dom'
import { dataMain } from "../data"

export const PageNotFound = () => {
  return (
    <React.Fragment>
      <div className="blank-marge"></div>
      <p className="pnfPadding">Page Not Found, click the link to go back to the MPTs Selector</p>
      <Link to='/'>
        <img src={dataMain.imgSrc[1]} alt="mptsSelector" className="btnHome pnfPadding" />
      </Link>
    </React.Fragment>
  )
}